import React from 'react';
import { UserOutlined, WarningFilled } from '@ant-design/icons';
import { BaseAlertBanner } from '@components';
import { useLingui } from '@lingui/react/macro';

import { ProfileHeaderNoDataWrapper, User } from './styled.tsx';

const ProfileHeaderNoData: React.FC = () => {
    const { t } = useLingui();
    const MESSAGE = t`Unable to load profile`;
    const DESCRIPTION = t`There was a problem fetching user data.`;

    return (
        <ProfileHeaderNoDataWrapper>
            <User>
                <UserOutlined />
            </User>
            <BaseAlertBanner type="warning" title={MESSAGE} description={DESCRIPTION} icon={<WarningFilled />} />
        </ProfileHeaderNoDataWrapper>
    );
};

export default ProfileHeaderNoData;
